<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "SubView"
}
</script>

<style scoped>

</style>